module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ga-Ha-Ic-Ja.f1978614.png";